import { render } from "./PayPassword.vue?vue&type=template&id=3afec903&scoped=true"
import script from "./PayPassword.vue?vue&type=script&lang=js"
export * from "./PayPassword.vue?vue&type=script&lang=js"

import "./PayPassword.vue?vue&type=style&index=0&id=3afec903&lang=less&scoped=true"

import exportComponent from "F:\\handzone_game\\10001-sdk\\web\\hzgamebox\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3afec903"]])

export default __exports__